// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function IconsGeneralCart2Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 18 18"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5zM5.302 13.71c.323-.675 2.288-1.335 3.698-1.335 1.41 0 3.382.66 3.697 1.335A5.92 5.92 0 019 15a5.92 5.92 0 01-3.698-1.29zm8.468-1.088c-1.072-1.304-3.675-1.747-4.77-1.747-1.095 0-3.697.443-4.77 1.748A5.962 5.962 0 013 9c0-3.308 2.693-6 6-6 3.308 0 6 2.692 6 6a5.962 5.962 0 01-1.23 3.623zM9 4.5a2.618 2.618 0 00-2.625 2.625A2.618 2.618 0 009 9.75a2.618 2.618 0 002.625-2.625A2.618 2.618 0 009 4.5zm0 3.75a1.123 1.123 0 01-1.125-1.125C7.875 6.502 8.377 6 9 6a1.124 1.124 0 110 2.25z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default IconsGeneralCart2Icon
/* prettier-ignore-end */
